/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useCallback, useState } from 'react';
import useAbortController from './useAbortController';
import axiosCall from '../../services/axios';
import { getErrorFromEndpoint, isObjEmptyOrNull, isStrEmptyOrNull } from '../../common/UtilityFunctions';

enum Status {
  LOADING = 'Loading',
  READY = '',
}

const useMaxmind = () => {
  const { get } = useAbortController();
  const [maxmindResp, setMaxmindResp] = useState(null);
  const [maxmindErrors, setMaxmindErrors] = useState('');
  const [maxmindStatus, setMaxmindStatus] = useState(Status.READY);

  const maxmindAPI = useCallback(async (): Promise<maxmindResponse> => {
    const urlPath = process.env.REACT_APP_MAXMIND;
    const request = { url: urlPath, method: 'post' };
    const config = get();

    const res = await axiosCall(request, config, {}, false)
      .then((res) => {
        if (!isObjEmptyOrNull(res)) {
          const err = getErrorFromEndpoint(res);
          if (isStrEmptyOrNull(err)) {
            setMaxmindResp(res);
            return res;
          } else {
            console.log(err);
            setMaxmindResp(null);
            setMaxmindErrors(err);
            return null;
          }
        }
        return null;
      })
      .catch((e: Error) => {
        console.log('Error using maxmindAPI in the useMaxmind hook: ', e);
        setMaxmindErrors(e.message);
        setMaxmindResp(null);
        return null;
      });
    setMaxmindStatus(Status.READY);
    return res;
  }, [get]);

  const processMaxmind = useCallback(async () => {
    setMaxmindResp(null);
    setMaxmindStatus(Status.LOADING);
    setMaxmindErrors('');
    const res = await maxmindAPI();
    return res;
  }, [maxmindAPI]);

  return { maxmindResp, maxmindStatus, maxmindErrors, processMaxmind };
};

export default useMaxmind;
